import { motion } from "framer-motion";
import { Building2, Landmark, HardHat, KeyRound, RefreshCcw, Layers } from "lucide-react";

const cards = [
  { icon: Building2, title: "Development Financing", desc: "Ground-up development", testid: "financing-card-development" },
  { icon: Landmark, title: "Bridge Loans", desc: "Acquisition & transitional capital", testid: "financing-card-bridge" },
  { icon: HardHat, title: "Construction Financing", desc: "Construction and completion", testid: "financing-card-construction" },
  { icon: KeyRound, title: "Acquisition Financing", desc: "Commercial acquisitions", testid: "financing-card-acquisition" },
  { icon: RefreshCcw, title: "Refinancing", desc: "Recapitalization & refinance", testid: "financing-card-refinancing" },
  { icon: Layers, title: "Structured Capital", desc: "Debt, mezzanine & equity", testid: "financing-card-structured" },
];

export default function FinancingCards() {
  return (
    <section className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10" data-testid="financing-cards-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-6"
          data-testid="financing-cards-overline"
        >
          Areas of Expertise
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.08] tracking-tight text-[#F5F5F5] mb-16"
          data-testid="financing-cards-headline"
        >
          Financing for every stage
          <br />
          <span className="italic text-[#D4AF37]">of the deal.</span>
        </motion.h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D4AF37]/15" data-testid="financing-cards-grid">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.12 }}
                className="group bg-[#0A0A0A] p-10 lg:p-12 hover:bg-[#0E0E0E] transition-colors duration-500"
                data-testid={c.testid}
              >
                <span className="inline-flex items-center justify-center w-12 h-12 border border-[#D4AF37]/35 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                  <Icon size={20} strokeWidth={1.25} />
                </span>
                <h3 className="mt-8 font-display text-xl sm:text-2xl font-light tracking-wide text-[#F5F5F5]">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm font-light leading-relaxed tracking-wide text-[#A3A3A3]">
                  {c.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
